class TransitionV2Entity {
  constructor({
    ...data
  }) {
    this.pk = data.pk;
    this.workflow = data.workflow;
    this.stateTransition = data.state_transition;
    this.ruleGroup = data.rule_group;
    this.allowedBy = data.allowed_by;
    this.entityAttribute = data.entity_attribute;
    this.attributeCondition = data.attribute_condition;
    this.isActive = data.is_active;
    this.notificationFrequency = data.notification_frequency;
    this.notificationLimit = data.notification_limit;
    this.notifyOnStateChange = data.notify_on_state_change;
    this.notifyOnEntry = data.notify_on_entry;
    this.notifyTime = data.notify_time;
    this.sla = data.sla;
    this.mapToSnakeCase = data => {
      return {
        pk: data.pk,
        sla: data.sla,
        is_active: data.isActive,
        notification_frequency: data.notificationFrequency,
        notification_limit: data.notificationLimit,
        notify_on_state_change: data.notifyOnStateChange,
        notify_time: data.notifyTime ?? 0,
        workflow: data.workflow?.pk ? data.workflow : {},
        notify_on_entry: data.notifyOnEntry,
        state_transition: data.stateTransition?.pk ? data.stateTransition : {},
        rule_group: data.ruleGroup?.pk ? data.ruleGroup : {},
        allowed_by: data.allowedBy?.length ? data.allowedBy : [],
        entity_attribute: data.entityAttribute || '',
        attribute_condition: data.attributeCondition || ''
      };
    };
  }
}
export default TransitionV2Entity;